export default "/images/46806230399167b2f86df1f5040fc87f.avif";